<app-custom-mat-table
  [dataSource]="dataSource"
  [columns]="myColumns"
  [recordCount]="recordCount"
  [pageSizes]="[10]"
  (page)="handlePageEvent($event)"
  [isLoading]="(products$ | async)?.loading!"
  [hidePageSize]="true"
></app-custom-mat-table>